module.exports = __webpack_public_path__ + "static/img/rrrr_15.a852ab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_15.png
// module id = GqIw
// module chunks = 1